import { Box, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import { TrackButton } from 'artkive/components/Tracker'

import VideoPosterTablet from 'images/ecom/home/video-poster/1080p.jpg'
import VideoPosterMobile from 'images/ecom/home/video-poster/cropped-720p.jpg'
import VideoPosterDesktop from 'images/ecom/home/video-poster/poster.jpg'

export const HeroWrap = withStyles(() => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '66vh',
  },
}))(Box)

export const Container = withStyles(() => ({
  root: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
}))(Box)

export const Overlay = withStyles(() => ({
  root: {
    background: 'linear-gradient(262.1deg, rgba(40, 37, 31, 0.06) 0%, rgba(40, 37, 31, 0.3) 100%)',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
  },
}))(Box)

export const ImagePlaceholder = withStyles((theme) => ({
  root: {
    backgroundImage: `url("${VideoPosterMobile}")`,
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    zIndex: 0,
    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url("${VideoPosterTablet}")`,
    },
    [theme.breakpoints.up('md')]: {
      backgroundImage: `url("${VideoPosterDesktop}")`,
    },
  },
}))(Box)

export const Video = styled('video')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  zIndex: 1,

  minWidth: '100%',
  minHeight: '100%',
  width: '100%',
  height: '100%',
  transform: 'translate(-50%, -50%)',
  objectFit: 'cover',
})

export const InfoWrap = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    maxWidth: '570px',
    position: 'relative',
    zIndex: 2,
    marginBottom: '5.2%', // should be in %
    marginLeft: '10.4%', // should be in %

    [theme.breakpoints.down('sm')]: {
      maxWidth: '336px',
      marginBottom: '9.66%', // should be in %
      marginLeft: '3.87%', // should be in %
    },
  },
}))(Box)

export const Title = withStyles((theme) => ({
  root: {
    textTransform: 'capitalize',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.875rem',
      lineHeight: 1.2,
    },
  },
}))(Typography)

export const SubTitle = withStyles((theme) => ({
  root: {
    fontWeight: 500,
    marginTop: '12px',
    color: 'white',
    maxWidth: '410px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '8px',
      maxWidth: '295px',
    },
  },
}))(Typography)

export const ActionButton = withStyles((theme) => ({
  root: {
    width: '180px',
    height: '48px',
    marginTop: '32px',
    [theme.breakpoints.down('sm')]: {
      width: '160px',
      marginTop: '20px',
    },
  },
}))(TrackButton)
